import "./Inquiry.module.css";
import Header from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function InquiryPage() {
  return <div>
      <Header />
      <Inquiry />
      <Footer />
    </div>;
}